import type { DashboardItem } from '../types/dashboard.types';
import { isThirdPartyRow } from './thirdPartyAgreements';

export const THIRD_PARTY_BLANK_COLUMN_IDS = ['dealer', 'customer', 'product', 'salesperson'] as const;

export const hiddenThirdPartyColumns = (rows: DashboardItem[]): Record<string, false> =>
    rows.length > 0 && rows.every(isThirdPartyRow)
        ? Object.fromEntries(THIRD_PARTY_BLANK_COLUMN_IDS.map((id) => [id, false as const]))
        : {};
